export const formatShopCategoryDate = (isoDate: string | null | undefined): string => {
    if (!isoDate) {
        return '';
    }

    const date = new Date(isoDate);

    if (Number.isNaN(date.getTime())) {
        return '';
    }

    return date.toLocaleDateString('en-US', {
        timeZone: 'America/Phoenix',
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
    });
};
